import { isFirebaseConfigured } from "@/auth/firebase";
import {
  googleSignInErrorMessage,
  resolvePostLoginPath,
  signInWithGoogle,
  subscribeAuth,
} from "@/auth/google-auth";

function escapeHtml(text: string): string {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function mountHomePage(root: HTMLElement): () => void {
  root.className = "page-shell page-home";
  const configured = isFirebaseConfigured();

  const redirectAfterLogin = () => {
    window.location.assign(resolvePostLoginPath());
  };

  const render = (signedIn: boolean, displayName: string | null) => {
    const greeting =
      signedIn && displayName
        ? `<p class="user-greeting">สวัสดี, <strong>${escapeHtml(displayName)}</strong></p>`
        : "";

    const primaryCta = signedIn
      ? ""
      : `<div class="login-google-bezel">
          <button type="button" id="google-sign-in" class="btn btn-google"${configured ? "" : " disabled"}>
            <span class="btn-google-icon" aria-hidden="true">G</span>
            ลงชื่อเข้าใช้ด้วย Google
          </button>
        </div>
        <p id="login-error" class="form-error login-error" role="alert" hidden></p>
        <p id="login-config-hint" class="hint login-hint"${configured ? " hidden" : ""}>
          ตั้งค่า <code>VITE_FIREBASE_API_KEY</code>, <code>VITE_FIREBASE_AUTH_DOMAIN</code>,
          และ <code>VITE_FIREBASE_PROJECT_ID</code> ใน <code>.env</code> (โฟลเดอร์โปรเจกต์)
        </p>`;

    root.innerHTML = `
      <main class="home-hero">
        <p class="eyebrow">Idle survival · จิตใจ</p>
        <h1>Mind Survival</h1>
        <p class="lede">
          เอาชีวิตรอดในโลกภายใน สะสมทรัพยากร ดูแลตัวละครของคุณ
          และกลับมาเล่นต่อเมื่อพร้อม
        </p>
        ${greeting}
        <div class="home-actions">
          ${primaryCta}
        </div>
      </main>
    `;

    const errorEl = root.querySelector<HTMLElement>("#login-error");
    const button = root.querySelector<HTMLButtonElement>("#google-sign-in");
    if (!button) return;

    const showError = (message: string) => {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    };

    button.addEventListener("click", () => {
      void (async () => {
        button.disabled = true;
        errorEl?.setAttribute("hidden", "true");
        try {
          await signInWithGoogle();
          redirectAfterLogin();
        } catch (err) {
          showError(googleSignInErrorMessage(err));
          button.disabled = !configured;
        }
      })();
    });
  };

  render(false, null);
  const unsub = subscribeAuth((user) => {
    if (user) {
      redirectAfterLogin();
      return;
    }
    render(false, null);
  });

  return unsub;
}
